<template>
  <div>
    <PromoCodeHead
            :countFilterParams="countFilterParams"
            :showFilter="showFilter"
            @toggleFilter="toggleFilter"
            @filter="$emit('filter')"
            @reload="$emit('reload')"
    />

    <div class="table-filter-wrap">
      <PromoCodeFilter
              :showFilter="showFilter"
              :filterGetParams="filterGetParams"
              @close="closeFilter"
              @changeFilter="data => $emit('changeFilter', data)"
              @resetFilter="$emit('resetFilter')"
      />

      <PromoCodeTable
              @showMore="$emit('showMore')"
              @resetFilter="$emit('resetFilter')"
              @updateTable="$emit('updateTable')"
              @reload="$emit('reload')"
      />
    </div>
  </div>
</template>

<script>


  import PromoCodeHead from "./PromoCodeHead/PromoCodeHead";
  import PromoCodeFilter from "./PromoCodeFilter/PromoCodeFilter";
  import PromoCodeTable from "./PromoCodeTable/PromoCodeTable";

  export default {
    name: "PromoCodeTableAdmin",

    components: {
      PromoCodeHead,
      PromoCodeFilter,
      PromoCodeTable,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },
    }
  }
</script>

<style scoped>

</style>
